document.addEventListener('DOMContentLoaded', function () {
  const interval = 400; 
  const maxAttempts = 10;
  let attempts = 0;

  const timer = setInterval(() => {
    attempts++;
    applyRingFilters();
    if (attempts >= maxAttempts) clearInterval(timer);
  }, interval);

  function applyRingFilters() {
    const path = window.location.pathname || "";
    if (!path.startsWith("/apps/ring-creator/")) return;

    const url = new URL(window.location.href);
    const qs = url.searchParams;

    const colorType = (qs.get("color_type") || "").toLowerCase();
    if (colorType !== "white") return;

    const isReferenceMatch = qs.get("ring_reference_id") === "25343";

    const isLabgrownMatch =
      path.includes("rb-stone-list") &&
      (qs.get("diamond_type") || "").toLowerCase() === "labgrown";

    if (!isReferenceMatch && !isLabgrownMatch) return;

    const desired = {
      white_color_to: "D",
      white_color_from: "F",
      min_carat: "2.00",
      max_carat: "2.99",
      clarity_to: "VVS2",
      clarity_from: "VS1",
      cut_to: "Ideal",
      cut_from: "Excellent"
    };

    const toSet = {};
    Object.keys(desired).forEach(key => {
      const existing = qs.get(key);
      if (existing !== desired[key]) {
        toSet[key] = desired[key];
      }
    });

    if (Object.keys(toSet).length === 0) {
      clearInterval(timer);
      return;
    }

    Object.entries(toSet).forEach(([k, v]) => qs.set(k, v));

    clearInterval(timer);
    window.location.replace(url.toString());
  }
});

(function() {
  let currentSelectedSize = ""; 

  function createRingSizeDropdown() {
    const fieldset = document.querySelector('fieldset[data-option-name="ring-size"]');
    if (!fieldset) return;
    if (fieldset.querySelector(".ring-size-dropdown")) return; 

    const radios = fieldset.querySelectorAll('input[type="radio"]');
    if (!radios.length) return;

    const select = document.createElement("select");
    select.className = "ring-size-dropdown";
    select.style.width = "50%";
    select.style.padding = "8px";
    select.style.border = "1px solid #ccc";
    select.style.borderRadius = "4px";
    select.style.fontSize = "16px";
    select.style.marginTop = "8px";

    const placeholder = document.createElement("option");
    placeholder.value = "";
    placeholder.textContent = "Select Size";
    placeholder.disabled = true;
    select.appendChild(placeholder);

    radios.forEach((radio) => {
      const label = fieldset.querySelector(`label[for="${radio.id}"]`);
      if (label) {
        const option = document.createElement("option");
        option.value = radio.value;
        option.textContent = label.textContent.trim();
        select.appendChild(option);
      }
    });

    if (currentSelectedSize) {
      select.value = currentSelectedSize;
    } else {
      select.value = ""; 
    }

    const legend = fieldset.querySelector("legend");
    if (legend) legend.insertAdjacentElement("afterend", select);
    else fieldset.prepend(select);

    radios.forEach((r) => {
      const lbl = fieldset.querySelector(`label[for="${r.id}"]`);
      if (lbl) lbl.style.display = "none";
      r.style.display = "none";
    });

    select.addEventListener("change", (e) => {
      const value = e.target.value;
      currentSelectedSize = value;

      const radio = Array.from(radios).find((r) => r.value === value);
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  const observer = new MutationObserver(() => {
    const fieldset = document.querySelector('fieldset[data-option-name="ring-size"]');
    if (fieldset && !fieldset.querySelector(".ring-size-dropdown")) {
      createRingSizeDropdown();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener("DOMContentLoaded", createRingSizeDropdown);
})();


// sort by js low to high

// document.addEventListener("DOMContentLoaded", function() {
//   function forceSelectLowToHigh() {
//     const sel = document.querySelector("#FormSelectFilter");
//     if (!sel) {
//       setTimeout(forceSelectLowToHigh, 100);
//       return;
//     }

//     sel.value = "price-ascending";
//     sel.dispatchEvent(new Event("change", { bubbles: true }));
//   }

//   setTimeout(forceSelectLowToHigh, 500);
// });


document.addEventListener("DOMContentLoaded", function() {
  const currentUrl = window.location.href;

  const url1 = "https://naturesparkle.com/apps/ring-creator/rb-setting-list?in_journey=true&jewelry_type=ring&view_type=grid&metal_type=White%20Gold%7C14K";
  const url2 = "https://naturesparkle.com/apps/ring-creator/rb-setting-list?in_journey=true&jewelry_type=ring&view_type=grid&metal_type=Rose%20Gold%7C14K";


  const redirectUrl = "https://naturesparkle.com/apps/ring-creator/rb-setting-list?in_journey=true&jewelry_type=ring&view_type=grid&metal_type=Yellow%20Gold%7C10K&supported_shape=Round";

  if (currentUrl === url1 || currentUrl === url2) {
    window.location.replace(redirectUrl);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  function hideBuyNowAndQty() {
    // Find the "Choose Stone" button
    const chooseStoneBtn = document.querySelector(".choose-stone-button");

    if (chooseStoneBtn) {
      const qtyAndAddToCartWrapper = document.querySelector(".flex.gap-2");
      if (qtyAndAddToCartWrapper) {
        qtyAndAddToCartWrapper.style.display = "none";
      }

      const paymentBtn = document.querySelector(".payment-button.button-default");
      if (paymentBtn) {
        paymentBtn.style.display = "none";
      }

      const paymentContainer = document.querySelector(".payment-button-container");
      if (paymentContainer) {
        paymentContainer.style.display = "none";
      }
    }
  }

  hideBuyNowAndQty();

  const observer = new MutationObserver(hideBuyNowAndQty);
  observer.observe(document.body, { childList: true, subtree: true });
});

// Slider on setting page mobile view

document.addEventListener("DOMContentLoaded", function () {
  const mainSlider = document.querySelector("#vdbrb_ring_main_slider");
  const thumbnails = document.querySelectorAll(".vdbrb_ring_thumbnail_data");
  if (!mainSlider || thumbnails.length === 0) return;

  function isMobile() {
    return window.innerWidth <= 768;
  }

  let startX = 0;
  let currentIndex = 0;

  mainSlider.addEventListener("touchstart", function (e) {
    if (!isMobile()) return;
    startX = e.touches[0].clientX;
  });

  mainSlider.addEventListener("touchend", function (e) {
    if (!isMobile()) return;
    const endX = e.changedTouches[0].clientX;
    const diff = startX - endX;
    if (Math.abs(diff) < 50) return;

    if (diff > 0) currentIndex++;
    else currentIndex--;

    if (currentIndex < 0) currentIndex = thumbnails.length - 1;
    if (currentIndex >= thumbnails.length) currentIndex = 0;

    const selectedThumb = thumbnails[currentIndex];
    const type = selectedThumb.getAttribute("data-type");

    // Create fade container
    const fadeContainer = document.createElement("div");
    fadeContainer.classList.add("vdb-rb-slider-banner-image", "vdb-rb-fade");

    if (type === "image") {
      const newSrc = selectedThumb.getAttribute("data-src");
      fadeContainer.innerHTML = `<img src="${newSrc}" alt="${newSrc}" onerror="this.src='https://phpstack-959587-3353921.cloudwaysapps.com/images/no-image.png'">`;
    } else if (type === "video") {
      const videoUrl = selectedThumb.getAttribute("data-video_url");
      fadeContainer.innerHTML = `
        <video autoplay muted playsinline controls style="width:100%;height:auto;border-radius:6px;">
          <source src="${videoUrl}" type="video/mp4">
          Your browser does not support the video tag.
        </video>`;
    }

    // Replace main content smoothly
    mainSlider.innerHTML = "";
    mainSlider.appendChild(fadeContainer);
    requestAnimationFrame(() => {
      fadeContainer.classList.add("vdb-rb-fade-in");
    });

    // Update active thumbnail class
    thumbnails.forEach(t => t.classList.remove("vdb-rb-thumbnail-item-active"));
    selectedThumb.classList.add("vdb-rb-thumbnail-item-active");
  });
});

(function () {
  const TARGET_TEXT = 'Accented';
  const NEW_TEXT = 'Unique';

  function replaceAccentedText() {
    document.querySelectorAll('#vdbrb_ring_type_slider .vdv-rb-item-title').forEach(el => {
      if (el.textContent.trim() === TARGET_TEXT) {
        el.textContent = NEW_TEXT;
      }
    });
  }

  // Initial run (for first paint)
  replaceAccentedText();

  // Observe Slick re-renders / DOM mutations
  const slider = document.getElementById('vdbrb_ring_type_slider');
  if (!slider) return;

  const observer = new MutationObserver(() => {
    replaceAccentedText();
  });

  observer.observe(slider, {
    childList: true,
    subtree: true
  });
})();

// Color swatch 

document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.card-swatch');
  if (!swatch) return;

  // Add active class manually (since you mentioned it already works)
  const swatchWrap = swatch.closest('.product-card-color-swatches');
  if (!swatchWrap) return;

  swatchWrap.querySelectorAll('.card-swatch').forEach(s => {
    s.classList.remove('active-swatch');
  });
  swatch.classList.add('active-swatch');

  const imageUrl = swatch.getAttribute('data-image');
  if (!imageUrl) return;

  const productCard = swatch.closest('.card-product');
  if (!productCard) return;

  const finalImage = imageUrl.startsWith('//')
    ? location.protocol + imageUrl
    : imageUrl;

  // 🔥 FORCE replace ALL product card images
  productCard.querySelectorAll('img.product_card_image').forEach(img => {
    img.src = finalImage;
    img.removeAttribute('srcset');
  });
});

(function () {
  let tooltip;

  function cleanText(text) {
    // Remove leading "10K ", "14K ", "18K ", etc.
    return text.replace(/^\d+\s*K\s*/i, '').trim();
  }

  function createTooltip(text) {
    tooltip = document.createElement('div');
    tooltip.className = 'swatch-tooltip';
    tooltip.textContent = cleanText(text);
    document.body.appendChild(tooltip);
  }

  function positionTooltip(el) {
    const rect = el.getBoundingClientRect();
    tooltip.style.left = rect.left + rect.width / 2 + 'px';
    tooltip.style.top = rect.top - 8 + 'px';
    tooltip.style.transform = 'translate(-50%, -100%)';
  }

  document.addEventListener('mouseover', function (e) {
    const swatch = e.target.closest('.card-swatch');
    if (!swatch) return;

    const rawText =
      swatch.getAttribute('data-option-value') ||
      swatch.getAttribute('title');

    if (!rawText) return;

    createTooltip(rawText);
    positionTooltip(swatch);
  });

  document.addEventListener('mouseout', function (e) {
    if (!e.target.closest('.card-swatch')) return;

    if (tooltip) {
      tooltip.remove();
      tooltip = null;
    }
  });
})();

document.addEventListener("DOMContentLoaded", function () {

  function formatDate(date) {
    return date.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric"
    });
  }

  function getDateRange(minDays, maxDays) {
    const start = new Date();
    const end = new Date();

    start.setDate(start.getDate() + minDays);
    end.setDate(end.getDate() + maxDays);

    return `${formatDate(start)} to ${formatDate(end)}`;
  }

  function appendDeliveryDates(container) {
    if (!container || container.dataset.datesAdded === "true") return;
    container.dataset.datesAdded = "true";

    const regularLabel = container.querySelector(
      'input[value="Regular Production"]'
    )?.closest("label");

    const expressLabel = container.querySelector(
      'input[value="Express Production"]'
    )?.closest("label");

    if (regularLabel && !regularLabel.querySelector(".delivery-date-regular")) {
      const regularDate = document.createElement("div");
      regularDate.className = "delivery-date-regular";
      regularDate.innerHTML = `
        <div class="expected-delivery">
          Expected Delivery:
          <span class="date-text">${getDateRange(18, 21)}</span>
        </div>
      `;
      regularLabel.appendChild(regularDate);
    }

    if (expressLabel && !expressLabel.querySelector(".delivery-date-express")) {
      const expressDate = document.createElement("div");
      expressDate.className = "delivery-date-express";
      expressDate.innerHTML = `
        <div class="expected-delivery">
          Expected Delivery:
          <span class="date-text">${getDateRange(7, 8)}</span>
        </div>
      `;
      expressLabel.appendChild(expressDate);
    }
  }

  // Target both AvisPlus blocks by key
  const targetKeys = [
    "KKLYWBOK0BCJKUIw43uJrXeTE8VK5K",
    "1f711e86-08c4-40bd-b248-fa8a32207a82"
  ];

  function run() {
    targetKeys.forEach(key => {
      const block = document.querySelector(
        `.avp-option[key="${key}"]`
      );
      appendDeliveryDates(block);
    });
  }

  run();

  // Safety net for dynamic re-render
  const observer = new MutationObserver(run);
  observer.observe(document.body, { childList: true, subtree: true });

});